// WhatsApp template değişkenleri satır sonu ve tab kabul etmiyor. Bu temizlik
// yazılan metnin kendisine değil, yalnızca önizlemeye ve gönderim payload'una
// uygulanır; aksi halde textarea'da yazarken imleç davranışı bozuluyordu.
export const sanitizeWhatsappText = value => {
    if (!value) return value;
    return value.replace(/[\r\n\t]+/g, " ").replace(/ {2,}/g, " ");
};
